import { useCallback, useMemo } from "react";

import { useMediaQuery } from "@mui/material";
import { FREE_PANORAMA_RANGE, OPEN_ALL_EXPLORE_DATA } from "@/constants/membership";
import { useGlobalStoreContext } from "@/context/globalStoreContext";

const useResponseCount = () => {
  const isMediaLg = useMediaQuery("(min-width:1200px)");
  const isMediaMd = useMediaQuery("(min-width:900px)");
  const isMediaSm = useMediaQuery("(min-width:700px)");

  const store = useGlobalStoreContext();

  const getFreeUserCount = useCallback(() => {
    if (isMediaLg) {
      return 21; // 4
    }
    if (isMediaMd) {
      return 12; // 3
    }

    if (isMediaSm) {
      return 8; // 2
    }

    return 8;
  }, [isMediaLg, isMediaMd, isMediaSm]);

  return useMemo(() => {
    return (!store.show_upsell || OPEN_ALL_EXPLORE_DATA) ? -1 : getFreeUserCount();
  }, [store.user_type, getFreeUserCount]);
};

export default useResponseCount;
